import { httpService } from '../../../../services/http.service';
import { BASE_URL, USER } from '../../../../constants/endpoints';
import bugsnagHandler from '../../../../services/bugsnag.service';

const { CONTROLLERS: { MARK_AS_UNPAID: { BASE: MARK_AS_UNPAID_BASE, VERSION: MARK_AS_UNPAID_VERSION } } } = USER;

export const markAsUnPaidAPIAction = async (customerId: string, externalId: string) => {
  if (!customerId || !externalId) {
    bugsnagHandler.notify('Invoice Hub - Mark as Unpaid Action - Missing customerId or externalId');
    return false;
  }
  try {
    const { data } = await httpService.post(`${BASE_URL}/api/${MARK_AS_UNPAID_VERSION}/${MARK_AS_UNPAID_BASE}/${customerId}/invoice/${externalId}/markAsUnpaid`);
    return data;
  } catch (e: any) {
    bugsnagHandler.notify('Invoice Hub - Mark as Unpaid Action - error marking invoice as unpaid', e);
    throw e;
  }
};
